const MONTH_LABEL = (params) => (params.value === undefined ? "" : params.value.toFixed(0));

function monthSeries({ seriesKeys }) {
    return [
        ...(seriesKeys || []).map((year) => ({
            type: "column",
            xKey: "month",
            yKey: year,
            yName: year,
            label: { formatter: MONTH_LABEL },
        })),
        {
            type: "line",
            xKey: "month",
            yKey: "average",
            yName: "Average",
            label: { formatter: MONTH_LABEL },
        },
    ];
}

const tableDefaults = {
    paginationPageSize: 150,
    defaultColDef: {
        sortable: true,
        filterFramework: true,
        filter: true,
        flex: 1,
        resizable: true,
    },
};

export const purchaseOrderValue = {
    report: "purchaseOrderValue",
    title: {
        text: "PO's Value by Customer",
    },
    yearSelector: true,
    chart: {
        title: {
            text: "PO's Value by Customer",
        },
        series: [{
            type: "column",
            xKey: "customer",
            yKey: "amount",
        }],
        axes: [{
            type: "category",
            position: "bottom",
            title: {
                text: "Customer",
            },
        }, {
            type: "number",
            position: "left",
            title: {
                text: "Amount",
            },
        }],
    },
    table: {
        ...tableDefaults,
        columnDefs: [{
            headerName: "Customer",
            field: "customer",
            width: 300,
        }, {
            headerName: "Price",
            field: "amount",
            width: 300,
            type: "currency",
            sortIndex: 1,
            sort: "desc",
        }],
    },
};

export const purchaseOrdersNumbersByCustomer = {
    report: "purchaseOrdersNumbersByCustomer",
    title: {
        text: "PO Numbers by Customer",
    },
    yearSelector: true,
    chart: {
        title: {
            text: "PO Numbers by Customer",
        },
        series: [{
            type: "column",
            xKey: "customer",
            yKey: "amount",
        }],
    },
    table: {
        ...tableDefaults,
        columnDefs: [{
            headerName: "Customer",
            field: "customer",
            width: 300,
            sortIndex: 0,
            sort: "desc",
        }, {
            headerName: "Number of PO's",
            field: "amount",
            width: 300,
        }],
    },
};

export const averageQuotePricePerYear = {
    report: "averageQuotePricePerYear",
    title: {
        text: "Average Quote per Year",
    },
    yearSelector: false,
    chart: {
        title: {
            text: "Average Quote per Year",
        },
        series: [{
            type: "column",
            xKey: "year",
            yKey: "averageQuote",
        }],
    },
    table: {
        ...tableDefaults,
        columnDefs: [{
            headerName: "Year",
            field: "year",
            width: 300,
        }, {
            headerName: "Average Quote",
            field: "averageQuote",
            width: 300,
            type: "currency",
            sortIndex: 1,
            sort: "desc",
        }],
    },
};

export const totalPerYear = {
    report: "totalPerYear",
    title: {
        text: "Total per Year",
    },
    yearSelector: false,
    chart: {
        title: {
            text: "PO's Value by Customer",
        },
        series: [{
            type: "column",
            xKey: "year",
            yKey: "averageQuote",
        }],
    },
    table: {
        ...tableDefaults,
        columnDefs: [{
            headerName: "Year",
            field: "year",
            width: 300,
        }, {
            headerName: "Average Quote",
            field: "averageQuote",
            width: 300,
            type: "currency",
            sortIndex: 1,
            sort: "desc",
        }],
    },
};

export const uptake = {
    report: "uptake",
    title: {
        text: "Purchase Order Uptake",
    },
    yearSelector: true,
    chart: {
        title: {
            text: "Purchase Order Uptake",
        },
        series: [{
            colors: ["red, green"],
            type: "pie",
            angleKey: "val",
            labelKey: "name",
            fills: ["green", "red"],
        }],
    },
};

export const uptakeAllTime = {
    report: "uptakeAllTime",
    title: {
        text: "Purchase Order Uptake All Time",
    },
    yearSelector: false,
    chart: {
        title: {
            text: "Purchase Order Uptake (All Years)",
        },
        series: [{
            fill: ["red", "green"],
            type: "column",
            xKey: "year",
            yKey: "noPurchaseOrder",
            yName: "No Purchase Order",
            stacked: true,
            label: { formatter: MONTH_LABEL },
        }, {
            type: "column",
            xKey: "year",
            yKey: "purchaseOrder",
            yName: "Purchase Order",
            stacked: true,
            label: { formatter: MONTH_LABEL },
        }],
    },
};

export const purchaseOrdersByMonthAndYear = {
    report: "purchaseOrdersByMonthAndYear",
    title: {
        text: "Purchase Order Uptake by Month",
    },
    yearSelector: false,
    chart: {
        title: {
            text: "Purchase Order Uptake by Month",
        },
        series: monthSeries,
    },
};

export const completedDesignChangesByMonth = {
    report: "completedDesignChangesByMonth",
    title: {
        text: "Completed Design Changes by Month",
    },
    yearSelector: false,
    chart: {
        title: {
            text: "Completed Design Changes by Month",
        },
        series: monthSeries,
    },
};

export const completedJobCardsByMonth = {
    report: "completedJobCardsByMonth",
    title: {
        text: "Completed Job Cards by Month",
    },
    yearSelector: false,
    chart: {
        title: {
            text: "Completed Job Cards by Month",
        },
        series: monthSeries,
    },
};
